const initialState = {
    newEmployeePermissions:[],
    newEmployeeLists: [],
    allNewEmployeeLists: [],
    newEmployeeStatus: [],
    changedNewEmployeeStatus: [],
    changedNewEmployeeCredentialsStatus: [],
    onboardingCandidateList: [],
    employeeBlackListDetails: {},
    userEmployeeActivityLogs: [],
    loadingUserEmployeeActivityLogs: false,
    loadingNewEmployee: false,
    errorsNewEmployee: {}
}

const newEmployeeReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_NEW_EMPLOYEEBYID_PENDING":
        case "ADD_NEW_EMPLOYEE_BASIC_INFORMATION_PENDING":
        case "ADD_NEW_EMPLOYEE_EMERGENCY_CONTACT_PENDING":
        case "ADD_NEW_EMPLOYEE_CONTACT_PENDING":
        case "ADD_NEW_EMPLOYEE_JOB_TITLE_PENDING":
        case "ADD_NEW_EMPLOYEE_ADDRESS_PENDING":
        case "ADD_NEW_EMPLOYEE_KYC_PENDING":
        case "ADD_NEW_EMPLOYEE_EDUCATION_PENDING":
        case "ADD_NEW_EMPLOYEE_CREDENTIALS_PENDING":
        case "ADD_NEW_EMPLOYEE_PREVIOUS_EMPLOYMENT_PENDING":
        case "ADD_NEW_EMPLOYEE_SOCIAL_MEDIA_PENDING":
        case "ADD_NEW_EMPLOYEE_BANK_DETAILS_PENDING":
        case "ADD_NEW_EMPLOYEE_FAMILY_DETAILS_PENDING":
        case "DELETE_NEW_EMPLOYEE_BANK_DETAILS_PENDING":
        case "DELETE_NEW_EMPLOYEE_KYC_DETAILS_PENDING":
        case "DELETE_NEW_EMPLOYEE_EDUCATION_DETAILS_PENDING":
        case "GET_ONBOARDING_CANDIDATE_LIST_PENDING":
        case "GET_NEW_EMPLOYEE_BLACK_LIST_PENDING":
        case "ADD_NEW_EMPLOYEE_BLACK_LIST_PENDING":
            return { ...state, 
                loadingNewEmployee: true,
                errorsNewEmployee: {}
            };


        case "GET_USER_EMPLOYEE_ACTIVITY_LOGS_PENDING":
            return {
                ...state,
                loadingUserEmployeeActivityLogs: true,
                userEmployeeActivityLogs: [],
                errorsNewEmployee: {}
            };
        
        case "ADD_NEW_EMPLOYEE_CONTACT_FULFILLED":
        case "ADD_NEW_EMPLOYEE_EMERGENCY_CONTACT_FULFILLED":
        case "ADD_NEW_EMPLOYEE_BASIC_INFORMATION_FULFILLED":
        case "ADD_NEW_EMPLOYEE_JOB_TITLE_FULFILLED":
        case "ADD_NEW_EMPLOYEE_ADDRESS_FULFILLED":
        case "ADD_NEW_EMPLOYEE_KYC_FULFILLED":
        case "ADD_NEW_EMPLOYEE_EDUCATION_FULFILLED":
        case "ADD_NEW_EMPLOYEE_PREVIOUS_EMPLOYMENT_FULFILLED":
        case "ADD_NEW_EMPLOYEE_SOCIAL_MEDIA_FULFILLED":
        case "ADD_NEW_EMPLOYEE_BANK_DETAILS_FULFILLED":
        case "ADD_NEW_EMPLOYEE_FAMILY_DETAILS_FULFILLED":
        case "DELETE_NEW_EMPLOYEE_BANK_DETAILS_FULFILLED":
        case "DELETE_NEW_EMPLOYEE_KYC_DETAILS_FULFILLED":
        case "DELETE_NEW_EMPLOYEE_EDUCATION_DETAILS_FULFILLED":
        case "ADD_NEW_EMPLOYEE_BLACK_LIST_FULFILLED":
            return {
              ...state,
              loadingNewEmployee: false,
              changedNewEmployeeStatus: action.payload,
              newEmployeePermissions: action.permissions,
              errorsNewEmployee: {},
            };
        case "ADD_NEW_EMPLOYEE_CREDENTIALS_FULFILLED":
            return {
                ...state,
                loadingNewEmployee: false,
                changedNewEmployeeCredentialsStatus: action.payload,
                newEmployeePermissions: action.permissions,
                errorsNewEmployee: {},
            };
        case "GET_NEW_EMPLOYEEBYID_FULFILLED":
            return {
                ...state,
                loadingNewEmployee: false,
                newEmployeeLists: action.payload?.data || [],
                newEmployeePermissions: action.permissions || [],
                errorsNewEmployee: {}
            };
        case "GET_ONBOARDING_CANDIDATE_LIST_FULFILLED":
            return {
                ...state,
                loadingNewEmployee: false,
                onboardingCandidateList: action.payload || [],
                errorsNewEmployee: {}
            };
        case "GET_NEW_EMPLOYEE_BLACK_LIST_FULFILLED":
            return {
                ...state,
                loadingNewEmployee: false,
                employeeBlackListDetails: action.payload?.data || action.payload || {},
                errorsNewEmployee: {}
            };
        case "GET_USER_EMPLOYEE_ACTIVITY_LOGS_FULFILLED":
            return {
                ...state,
                loadingUserEmployeeActivityLogs: false,
                userEmployeeActivityLogs: Array.isArray(action.payload) ? action.payload : [],
                errorsNewEmployee: {}
            };
        case "ADD_NEW_EMPLOYEE_BASIC_INFORMATION_REJECTED":
        case "ADD_NEW_EMPLOYEE_CONTACT_REJECTED":
        case "ADD_NEW_EMPLOYEE_EMERGENCY_CONTACT_REJECTED":
        case "ADD_NEW_EMPLOYEE_JOB_TITLE_REJECTED":
        case "ADD_NEW_EMPLOYEE_ADDRESS_REJECTED":
        case "ADD_NEW_EMPLOYEE_KYC_REJECTED":
        case "ADD_NEW_EMPLOYEE_EDUCATION_REJECTED":
        case "ADD_NEW_EMPLOYEE_PREVIOUS_EMPLOYMENT_REJECTED":
        case "ADD_NEW_EMPLOYEE_SOCIAL_MEDIA_REJECTED":
        case "ADD_NEW_EMPLOYEE_BANK_DETAILS_REJECTED":
        case "ADD_NEW_EMPLOYEE_FAMILY_DETAILS_REJECTED":
        case "DELETE_NEW_EMPLOYEE_BANK_DETAILS_REJECTED":
        case "DELETE_NEW_EMPLOYEE_KYC_DETAILS_REJECTED":
        case "DELETE_NEW_EMPLOYEE_EDUCATION_DETAILS_REJECTED":
        case "GET_NEW_EMPLOYEEBYID_REJECTED":
        case "GET_ONBOARDING_CANDIDATE_LIST_REJECTED":
        case "GET_NEW_EMPLOYEE_BLACK_LIST_REJECTED":
        case "ADD_NEW_EMPLOYEE_BLACK_LIST_REJECTED":
            return { ...state, loadingNewEmployee: false, errorsNewEmployee: action.payload };


        case "GET_USER_EMPLOYEE_ACTIVITY_LOGS_REJECTED":
            return {
                ...state,
                loadingUserEmployeeActivityLogs: false,
                userEmployeeActivityLogs: [],
                errorsNewEmployee: action.payload
            };
            
        case "RESET_NEW_EMPLOYEE_STATUS":
            return {
                ...state,
                loadingNewEmployee: false,
                changedNewEmployeeStatus: [],
                errorsNewEmployee: {}
            };
        case "RESET_NEW_EMPLOYEE_LIST":
            return {
                ...state,
                loadingNewEmployee: false,
                newEmployeeLists: [],
                employeeBlackListDetails: {},
                errorsNewEmployee: {}
            };
        case "RESET_NEW_EMPLOYEE_ERRORS":
            return {
                ...state,
                errorsNewEmployee: {}
            };
        case "RESET_NEW_EMPLOYEE_CREDENTIALS_STATUS":
            return {
                ...state,
                changedNewEmployeeCredentialsStatus: [],
                errorsNewEmployee: {}
            };
        default:
            return state;
    }
}

export default newEmployeeReducer;
